import { Heading, Typography } from '@altify/components';
import BackButton from 'components/BackButton/BackButton';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import { ReactNode } from 'react';

const CryptoWithdrawalWrapper = ({
  isLoading,
  title,
  description,
  bodyContent,
  buttons,
}: {
  isLoading: boolean;
  title: string;
  description?: string;
  bodyContent: ReactNode;
  buttons: ReactNode;
}) => {
  return (
    <div className="h-full py-4 px-4 md:px-8">
      <BackButton className={'w-full text-left lg:bg-body-background mt-1 ml-0 pl-6 lg:-mt-4 pt-2 lg:ml-0 lg:pl-0 lg:pt-0'} />
      <div className="w-full items-center flex flex-col mb-[80px]">
        <div className="flex flex-col items-center mt-4 lg:mt-14 gap-4 max-w-[600px] w-full">
          <Heading level={3} className="mb-4">
            {title}
          </Heading>
          {description && (
            <Typography
              size="large"
              className="w-full mb-4 text-center text-neutral-300 px-4">
              {description}
            </Typography>
          )}
          <div className="flex flex-col items-center gap-6 w-full">
            {isLoading ? (
              <div className="mt-12">
                <CustomLoader />
              </div>
            ) : (
              <div className="flex flex-col rounded-xl bg-background p-8 gap-4 w-full">
                {bodyContent}
              </div>
            )}
            {buttons}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptoWithdrawalWrapper;
